import React from 'react';
import { Tag, Tooltip } from 'antd';
import { SwapOutlined, RollbackOutlined } from '@ant-design/icons';
import { AssignButton } from '../JobList/styledComponents';

const multiSelectFilter = (row, columnId, filterValue) => {
  if (!filterValue || filterValue.length === 0) return true;
  const val = row.getValue(columnId);
  const strVal = val != null ? String(val) : 'N/A';
  return filterValue.includes(strVal);
};

export const createGroupQueueColumns = ({ onClaim, onRelease, userId }) => [
  {
    id: 'jobNumber',
    accessorKey: 'jobNumber',
    header: 'Job ID',
    size: 120,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => getValue() || 'N/A'
  },
  {
    id: 'doctorName',
    accessorFn: row => row.author,
    header: 'Doctor',
    size: 180,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => {
      const val = getValue();
      return val ? <span title={val}>{val.length > 22 ? val.slice(0, 22) + '...' : val}</span> : 'N/A';
    }
  },
  {
    id: 'patientName',
    accessorKey: 'patientName',
    header: 'Patient',
    size: 160,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => {
      const val = getValue();
      return val ? <span title={val}>{val.length > 20 ? val.slice(0, 20) + '...' : val}</span> : 'N/A';
    }
  },
  {
    id: 'facility',
    accessorFn: row => row.facility?.facilityName,
    header: 'Facility',
    size: 180,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => {
      const val = getValue();
      return val ? <span title={val}>{val.length > 22 ? val.slice(0, 22) + '...' : val}</span> : 'N/A';
    }
  },
  {
    id: 'billerGroup',
    accessorFn: row => row.assignedBiller?.billerGroups?.map(g => g.groupName).join(', ') || '',
    header: 'Biller Group',
    size: 180,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => getValue() || 'N/A'
  },
  {
    id: 'ageInDays',
    accessorFn: row =>
      row.submissionTime ? Math.floor((Date.now() - row.submissionTime) / 86400000) : null,
    header: 'Age (days)',
    size: 110,
    enableSorting: true,
    enableColumnFilter: false,
    cell: ({ getValue }) => {
      const days = getValue();
      if (days == null) return 'N/A';
      const overdue = days > 7;
      return (
        <span style={{ color: overdue ? '#ff4d4f' : 'inherit', fontWeight: overdue ? 700 : 400 }}>
          {days}
        </span>
      );
    }
  },
  {
    id: 'claimStatus',
    header: 'Status',
    size: 150,
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ row }) => {
      const { claimedBiller } = row.original;
      if (!claimedBiller) return <Tag color='green'>Available</Tag>;
      if (claimedBiller.id === userId) return <Tag color='blue'>Claimed by you</Tag>;
      return <Tag color='default'>Claimed by {claimedBiller.fullName}</Tag>;
    }
  },
  {
    id: 'actions',
    header: '',
    size: 120,
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ row }) => {
      const { jobId, claimedBiller } = row.original;
      const claimedByMe = claimedBiller?.id === userId;
      if (claimedByMe) {
        return (
          <Tooltip title='Release back to group queue'>
            <AssignButton onClick={() => onRelease(jobId)} icon={<RollbackOutlined />}>
              Release
            </AssignButton>
          </Tooltip>
        );
      }
      if (claimedBiller) return null;
      return (
        <Tooltip title='Claim this job'>
          <AssignButton type='primary' onClick={() => onClaim(jobId)} icon={<SwapOutlined />}>
            Claim
          </AssignButton>
        </Tooltip>
      );
    }
  }
];
